var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"rs_skip",attrs:{"id":"widget-guide-list-counter","data-badge":_vm.count}})
}
var staticRenderFns = []

export { render, staticRenderFns }